import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';

import 'next/stylesheets/components/team-wide-id';

Component('tr-team-wide-id', {
  mixins: [eventListenerMixin],

  connected() {
    this.link = this.querySelector('a');
    this.input = this.querySelector('input');

    if (document.queryCommandSupported('copy')) {
      this.link.classList.remove('not-supported');

      this.listenTo(this.link, 'click', () => {
        this.input.select();
        document.execCommand('copy');

        this.link.classList.add('copied');
        setTimeout(() => this.link.classList.remove('copied'), 2000);
      });
    }
  },

  disconnected() {
    this.stopListening();
  },
});
